import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/session';

// Crée le contexte
const PatientDoctorContext = createContext();

// Hook pour utiliser le contexte
export const usePatientDoctorContext = () => useContext(PatientDoctorContext);

// Fournisseur du contexte
export const PatientDoctorProvider = ({ children }) => {
  const [patients, setPatients] = useState([]);
  const loading = useRef(null);

  // Fonction pour mettre à jour la liste des patients
  const updatePatients = (newPatients) => {
    setPatients(newPatients);
  };

  // Pages opened straight from the menu load the list themselves, once.
  const ensurePatients = useCallback(() => {
    if (!loading.current) {
      loading.current = axios
        .get(`${API_BASE_URL}/api/patients`)
        .then((response) => {
          setPatients(Array.isArray(response.data) ? response.data : []);
        })
        .catch((error) => {
          loading.current = null;
          throw error;
        });
    }
    return loading.current;
  }, []);

  // Fetches the list again (changes made by colleagues).
  const reloadPatients = useCallback(() => {
    loading.current = null;
    return ensurePatients();
  }, [ensurePatients]);

  return (
    <PatientDoctorContext.Provider value={{ patients, updatePatients, ensurePatients, reloadPatients }}>
      {children}
    </PatientDoctorContext.Provider>
  );
};

// Patient list for a page that may be opened on its own.
export const usePatientList = () => {
  const { patients, ensurePatients } = usePatientDoctorContext();
  useEffect(() => {
    ensurePatients().catch(() => {});
  }, [ensurePatients]);
  return patients;
};

// Gives the patient list to a page written to receive it from the patients page.
export const WithPatients = ({ component: Component, ...props }) => {
  const patients = usePatientList();
  return <Component patients={patients} {...props} />;
};
